// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgCar = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.444 3.5a1.25 1.25 0 0 0-1.233 1.045L4.635 8h10.73l-.576-3.455A1.25 1.25 0 0 0 13.556 3.5H6.444ZM16.99 8.62l-.72-4.322A2.75 2.75 0 0 0 13.556 2H6.444a2.75 2.75 0 0 0-2.712 2.298l-.72 4.321A2.745 2.745 0 0 0 2 10.75v3.5c0 .966.784 1.75 1.75 1.75H4v1.25a.75.75 0 0 0 1.5 0V16h9v1.25a.75.75 0 0 0 1.5 0V16h.25A1.75 1.75 0 0 0 18 14.25v-3.5c0-.86-.394-1.627-1.011-2.13Zm-1.739.88H4.75c-.69 0-1.25.56-1.25 1.25v3.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-3.5c0-.69-.56-1.25-1.25-1.25ZM6 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5ZM4.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm9.25.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5ZM12.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"
    />
  </svg>
)

export default SvgCar
